module.exports = __webpack_public_path__ + "static/media/gi.c817b88a.png";